import React from 'react';

import RedirectPage from './UI/Pages/RedirectPage/redirect.page';
import Login from './UI/Pages/Login/login.page';
import SSOCallback from './UI/Pages/SSOCallback/ssocallback.page';
import SetUpAccount from './UI/Pages/SetUpAccount/setUpAccount';
import VerifyCode from './UI/Pages/VerifyCode/verifyCode.page';
import ForgotPassword from './UI/Pages/ForgotPassword/forgotPassword';
import ResetPassword from './UI/Pages/ResetPassword/resetPassword';
import ForcePasswordChange from './UI/Pages/ForcePasswordChange/forcePasswordChange';
import TestPage from './UI/Pages/TestPage/test';
import GoogleTwoFactorPage from './UI/Pages/GoogleTwoFactor/google-twofactor.page';

const publicPages = [
  {
    path: '/',
    element: <RedirectPage />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/test',
    element: <TestPage />,
  },
  {
    path: '/callback',
    element: <SSOCallback />
  },
  {
    path: '/google-2fa',
    element: <GoogleTwoFactorPage />
  },
  {
    path: '/reset-password',
    element: <ResetPassword />,
  },
  {
    path: '/force-password-change',
    element: <ForcePasswordChange />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPassword />,
  },
  {
    path: '/set-up-account',
    element: <SetUpAccount />,
  },
  {
    path: '/activate',
    element: <VerifyCode />,
  },
];

export default publicPages;
